module.exports = __webpack_public_path__ + "images/icons/icon-gift-0ac1d363d480edea4a67d79fdb2e996d.svg";